var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasVm)?_c('span',[_vm._v(" "+_vm._s(_vm.vm.state)+" ("+_vm._s(_vm.vm.name)+") "+_vm._s(_vm.extra_info)+" ")]):_c('span',[_vm._v(" NO VM ")])])}
var staticRenderFns = []

export { render, staticRenderFns }